import createICS from './createICS';
import getSyncFuncs from './getSyncFuncs';
import sync, { getSyncFunc } from './sync';
import syncGoogle from './syncGoogle';
import syncOutlook from './syncOutlook';

export const actions = {
    createICS,
    getSyncFuncs,
    getSyncFunc,
    sync,
    syncGoogle,
    syncOutlook,
};

export default actions;
